import React, {Fragment, useContext} from "react";
import {SearchOptionsContext} from "../../context/search-options-context";
import RangeSlider from "../OfferListPage/RangeSlider";

function StepForBudget(props) {

    const searchOptions = useContext(SearchOptionsContext);

    return (
        <Fragment>

            <div className="config-modal-body">

                <h5 className="center">Ile chcesz płacić miesięcznie?</h5>
                <RangeSlider
                    onChange={budget => props.onChange(budget)}
                    items={searchOptions.installments}
                    range={{
                        from: props.budget.from || null,
                        to: props.budget.to || null
                    }}
                    unit="zł"
                    placeholder={["Rata od", "Rata do"]}
                />

            </div>

            <div className="config-modal-footer">

                <div className="flex">
                    <button type="button" className="back" onClick={props.onBackClick}><i className="fa fa-angle-left"></i> Wstecz</button>
                    <button type="button" onClick={props.onNextClick}>Dalej <i className="fa fa-angle-right"></i></button>
                </div>

            </div>
        </Fragment>
    );
}

export default StepForBudget;
